module.exports = __webpack_public_path__ + "img/pc-list-two-add.487b8875.jpg";